import cx from 'classnames'

export const FormStack = ({ children, className, ...props }) => <div className={cx('tw:grid tw:gap-6', className)} {...props}>{children}</div>
